import { EXTENSION_IDENTIFIER } from "./serviceConstant";

export const dataCenterMap = {
  US: "https://www.zohoapis.com",
  EU: "https://www.zohoapis.eu",
  AU: "https://www.zohoapis.com.au",
  IN: "https://www.zohoapis.in",
  China: "https://www.zohoapis.com.cn",
  JP: "https://www.zohoapis.jp",
};

export const accountUrlMap = {
  US: "https://accounts.zoho.com",
  AU: "https://accounts.zoho.com.au",
  EU: "https://accounts.zoho.eu",
  IN: "https://accounts.zoho.in",
  China: "https://accounts.zoho.com.cn",
  JP: "https://accounts.zoho.jp",
  SA: "https://accounts.zoho.sa",
  CA: "https://accounts.zohocloud.ca",
};

export const WIDGET_NAME = "Easy Cellcast by Easy Pluginz";
export const WIDGET_URL = `https://widgets.${EXTENSION_IDENTIFIER}.v2.easy-pluginz.com/relatedlist`;
export const WIDGET_DESCRIPTION =
  "The related list Widget allow you view existing message and send new message with schedule functionality";
export const RELATEDLIST_WIDGET_TYPE = "RELATED_LIST";
